export enum Activations {
	WeekBefore = -7,
	DayBefore = -1,
	ExactDay = 0,
}
